import React, { Component } from 'react'
import { Alarm, ArrowForward } from '@mui/icons-material';

import { getProperty } from '../../helpers/properties'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { getStudentProgress, getOfferData, getCourseDetails } from '../../services/vu'
import { isEqual, sortBy, uniq } from 'lodash'
import { getEnrolUrl, isBlockedStudentConfiguration, isEligibleToAcceptOffer, isEligibleToEnrolNow, hasSanctions } from '../../helpers/enrolment'
import CommencementStatus from '../../enums/CommencementStatus'
import Loading from './Loading'
import { getConfiguration } from '../../helpers/configuration'
import ResidencyType from '../../enums/ResidencyType'
import { fetchCourses } from '../../actions/courses'
import { fetchCourse } from '../../actions/course'
import { fetchPersonalDataIfNeeded } from '../../actions/personalDetails'

const mapDispatchToProps = dispatch => {
  return {
    fetchCourses: () => {
      dispatch(fetchCourses())
      dispatch(fetchCourse())
    },
    clearCourses: () => {
      dispatch(clearCourses())
    },
    fetchPersonalDetails: () => {
      dispatch(fetchPersonalDataIfNeeded())
    }
  }
}

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, personalDetails }) => {
  return {
    courseId: selectedCourseCode,
    course: selectedCourse,
    personalDetails: personalDetails.data,
    commencementStatus: selectedCourse.isCommencing,
    courseAttemptStatus: selectedCourse.courseAttemptStatus,
    enrolmentYearsAsString: selectedCourse.enrolmentYearsAsString ? selectedCourse.enrolmentYearsAsString : "",
    courseStage: selectedCourse.courseStage,
    isSelfManagedCourse: selectedCourse.isSelfManagedCourse,
    loadingPersonalDetails: personalDetails.isFetchingPersonalDetails
  }
}

class EnrolmentNew extends Component {
  constructor(props) {
    super(props)

    this.state = {
      yearMessage: '',
      offers: [],
      loadingEnrolmentProgress: true,
      loadingOfferData: false,
      completedEnrolment: true
    }
  }

  componentDidMount() {
    this.props.fetchPersonalDetails()
    this.initialiseEnrolmentIsOpenMessage()
    this.getOfferData()
    this.updateEnrolUrl()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.courseId !== null && prevProps.courseId !== this.props.courseId) {
      this.props.fetchPersonalDetails()
      this.updateEnrolUrl()
      this.getOfferData()
      this.initialiseEnrolmentIsOpenMessage()
    }
  }

  initialiseEnrolmentIsOpenMessage = () => {
    let yearMessage = this.getYearMessage()
    this.setState({
      yearMessage: yearMessage
    })
  }

  updateEnrolUrl = () => {
    this.setState({
      loadingEnrolmentProgress: true
    })

    //set Flag if student has completed enrolment
    getStudentProgress(this.props.courseId).then(progress => {
      this.setState({
        loadingEnrolmentProgress: false,
        completedEnrolment: progress && progress.currentPage && progress.currentPage.indexOf('thankyou') > -1
      })
    })
  }

  getCourseDetails = () => {
    this.setState({
      loadingOfferData: true
    })

    let queryParams = {};
    queryParams['attemptNumber'] = course.attemptNumber;
    queryParams['versionNumber'] = course.versionNumber;
    queryParams['courseSSPNo'] = course.parentSSPNo;
    queryParams['parentSSPNo'] = course.parentSSPNo;

    getCourseDetails(this.props.courseId, queryParams)
      .then(course => {
        if (!course.isStudyPlanExpanded) {
          this.scheduleRestApiCall()
        } else {
          this.setState({
            loadingOfferData: false
          })
          //refresh the courses
          sessionStorage.removeItem('COURSES')
          this.props.fetchCourses()
        }
      })
      .catch(error => {
        //TODO do this error handling
      })
  }

  scheduleRestApiCall = () => {
    setTimeout(() => {
      this.getCourseDetails()
    }, 30000)
  }

  getOfferData = () => {
    if (this.props.courseStage === 'OFF') {
      this.setState({
        loadingOfferData: true
      })

      //set offers
      getOfferData(this.props.courseId)
        .then(offerFilter => {
          let offers = offerFilter.filter(offer => offer.courseSSP === this.props.course.courseSSPNo)
          if (offers.length > 0 && offers[0].outcomeCode === 'accept' && this.props.isSelfManagedCourse && new Date(offers[0].courseEarliestAdmissionDate) < new Date()) {
            this.getCourseDetails()
          }

          this.setState({
            loadingOfferData: false,
            offers: offers
          })
        })
        .catch(() => {
          this.setState({
            loadingOfferData: false,
            offers: []
          })
        })
    }
  }

  getEnrolUrl = () => {
    const { commencementStatus, courseId, enrolmentYearsAsString, courseAttemptStatus } = this.props

    const { completedEnrolment, offers } = this.state

    return getEnrolUrl(commencementStatus, courseId, completedEnrolment, enrolmentYearsAsString, courseAttemptStatus, offers)
  }

  getYearMessage = () => {
    //get enrolment years and get the latest
    return this.props.enrolmentYearsAsString
  }

  isDomesticStudent = () => {
    return ResidencyType.Domestic.includes(this.props.personalDetails.stuCitizenCd)
  }

  isContinuingStudent = () => {
    return !this.props.commencementStatus
  }

  isDomesticContinuingStudent = () => this.isDomesticStudent() && this.isContinuingStudent()

  render() {
    if (this.state.loadingEnrolmentProgress || this.props.loadingPersonalDetails || this.state.loadingOfferData) {
      return <Loading />
    }
    let eligibleToEnrolNow = isEligibleToEnrolNow(this.props.course, hasSanctions(this.props.personalDetails, this.props.courseId))
    let eligibleToAcceptOffer = isEligibleToAcceptOffer(this.props.course)

    if (this.props.personalDetails && !(eligibleToEnrolNow || eligibleToAcceptOffer)) {
      return <Redirect to={`${getConfiguration('baseUrl')}/enrolments`} />
    }

    return (
      <div className="page page-enrolments">
        {eligibleToEnrolNow && <h1 className="page__title">Enrolment is open</h1>}
        {eligibleToAcceptOffer && this.state.offers.length > 0 && this.state.offers[0].outcomeCode === 'NA' && <h1 className="page__title">Accept your offer</h1>}
        {eligibleToEnrolNow && this.isDomesticContinuingStudent() && (
          <p className="page__intro-txt">
            We have redesigned our online enrolment system.{' '}
            <a className="txt-link" href="https://www.youtube.com/watch?v=6lc0U4ClLSQ" target="_blank">
              Watch a video
            </a>{' '}
            about how to re-enrol using our new system or{' '}
            <a className="txt-link" href="https://askvu.vu.edu.au/app/answers/detail/a_id/1835" target="_blank">
              read the how to guide
            </a>
            . You can also call VUHQ if you have any issues on <b>+61 3 9919 6100</b>.
          </p>
        )}
        <div className="sidenote sidenote--warning">
          <div className="sidenote__content center-xs">
            {eligibleToEnrolNow && (
              <h2>
                Enrolment is open
                {this.state.yearMessage ? ' for ' + this.state.yearMessage : ''}
              </h2>
            )}
            <div className="row">
              <div className="col-xs-12 center-xs">
                {(eligibleToEnrolNow || (eligibleToAcceptOffer && this.state.offers.length > 0 && this.state.offers[0].outcomeCode === 'NA')) && (
                  <a className="btn btn-lg btn-primary btn-enrol" href={this.getEnrolUrl()}>
                    {eligibleToEnrolNow ? 'Enrol Now' : eligibleToAcceptOffer && this.state.offers.length > 0 && this.state.offers[0].outcomeCode === 'NA' ? 'Accept Offer' : null}
                    <ArrowForward className="btn-point-events" />
                  </a>
                )}
                {eligibleToAcceptOffer && this.state.offers.length > 0 && this.state.offers[0].outcomeCode === 'accept' ? (
                  !this.props.isSelfManagedCourse || (this.props.isSelfManagedCourse && new Date(this.state.offers[0].courseEarliestAdmissionDate) > new Date()) ? (
                    <p className="txt-lg">Your response has been successfully updated, thank you. You will receive further information via email.</p>
                  ) : (
                    <p>Updating your offer response. This may take a few minutes, please wait.</p>
                  )
                ) : null}
                {eligibleToAcceptOffer && this.state.offers.length > 0 && this.state.offers[0].outcomeCode === 'defer' ? (
                  this.state.offers[0].notes === '6 month deferral requested' ? (
                    <p>You requested to defer your Offer for 6 months, please check your email for further advice.</p>
                  ) : (
                    <p>You requested to defer your Offer for 12 months, please check your email for further advice.</p>
                  )
                ) : null}
                {eligibleToEnrolNow && (
                  <p>
                    <a className="txt-link" href="https://www.vu.edu.au/current-students/your-course/fees/pay-your-fees/census-payment-deadlines">
                      <Alarm /> View census and payment deadlines
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EnrolmentNew)
